import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createGraphsReportSlice = (set, get) => ({
    graphs: {
        loading: false,
        data: [],
        monthData: []
    },
    getGraphsData: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ graphs: { ...state.graphs, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: "/v1/businessPanel/BusinessBranchSaleReport/null/null",
                headers: { token }
            });
            set(state => ({ graphs: { ...state.graphs, loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ graphs: { ...state.graphs, loading: false } }));
        }
    },
    getMonthsGraphsData: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ graphs: { ...state.graphs, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: "/v1/businessPanel/GetBusinessProcessReport",
                headers: { token }
            });
            set(state => ({ graphs: { ...state.graphs, loading: false, monthData: resp.data } }));
        } catch (error) {
            set(state => ({ graphs: { ...state.graphs, loading: false } }));
        }
    }
});
